import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop } from 'lodash';

import { dispatchMaker } from 'helpers/utils';
import { uploadCoverImage, updateProfile } from 'redux/auth/actions';

import {
  EditableImage,
  injectIntl,
  ProfileBanner,
} from 'components';

const CardCover = ({ image, imageEditable, info, uploadCoverImage, updateProfile }) => {
  const onUpload = ({ filetype, imageBase64, onRequestClose }) => {
    uploadCoverImage({
      base64: imageBase64,
      filetype,
      onSuccess: onRequestClose,
    });
  };

  const onRemove = ({ onRequestClose }) => {
    updateProfile({ coverImageUrl: '', onSuccess: onRequestClose });
  };

  const renderer = ({ onClick, uploadImageDialog }) => (
    <div>
      <ProfileBanner
        className="upload-photo-button"
        img={image}
        onClick={imageEditable ? onClick : noop}
        style={imageEditable ? {} : { pointerEvents: 'none' }}
        userType={info.currentRoleId}
      />
      {uploadImageDialog}
    </div>
  );
  renderer.propTypes = {
    uploadImageDialog: PropTypes.node.isRequired,

    onClick: PropTypes.func.isRequired,
  };
  return (
    <EditableImage
      image={image}
      isBanner
      onUpload={onUpload}
      onRemove={onRemove}
      renderer={renderer}
    />
  );
};

CardCover.propTypes = {
  image: PropTypes.string,
  imageEditable: PropTypes.bool,
  info: PropTypes.shape({}),

  uploadCoverImage: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
};

CardCover.defaultProps = {
  image: '',
  imageEditable: false,
  info: {},
};

/* istanbul ignore next */
const mapStateToProps = (/* state */) => ({
});
const mapDispatchToProps = dispatch => ({
  ...dispatchMaker([
    [uploadCoverImage, 'uploadCoverImage'],
    [updateProfile, 'updateProfile'],
  ])(dispatch),
});

const wrappedCardCover = connect(mapStateToProps, mapDispatchToProps)(injectIntl(CardCover));
wrappedCardCover.displayName = 'CardCover';

export default wrappedCardCover;
